import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=7ddd6ddf&scoped=true&"
import script from "./ClassList.ts?vue&type=script&lang=ts&"
export * from "./ClassList.ts?vue&type=script&lang=ts&"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=7ddd6ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd6ddf",
  null
  
)

export default component.exports